type Props = {
  message?: string;
};

export function SettingsFirestoreError({ message }: Props) {
  if (!message) return null;
  return <p className="text-sm text-red-600">{message}</p>;
}
